import React from 'react';

/**
 * White surface panel used for cards/sections on the canvas.
 */
const Panel = ({ className = '', children, padding = true, ...rest }) => (
  <div
    className={`bg-white dark:bg-secondary-800 border border-secondary-200 dark:border-secondary-700 rounded-lg ${
      padding ? 'p-4' : ''
    } ${className}`}
    {...rest}
  >
    {children}
  </div>
);

export default Panel;
